import React from 'react';
import { Card, CardContent } from '../ui/card';
import { brl, pct, days, Delta, fieldMessage } from './format';

const CARDS = [
  { key: 'frete_medio', label: 'Frete médio cobrado', fmt: brl },
  { key: 'pct_frete', label: 'Frete sobre o pedido', fmt: pct },
  { key: 'pct_gratis', label: 'Pedidos com frete grátis', fmt: pct },
  { key: 'prazo_medio', label: 'Prazo médio prometido', fmt: null },
  { key: 'ticket_com_gratis', label: 'Ticket com frete grátis', fmt: brl },
  { key: 'ticket_sem_gratis', label: 'Ticket sem frete grátis', fmt: brl },
];

export const LogisticsCards = ({ cards, unidade, ctx }) => (
  <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3" data-testid="logistics-cards">
    {CARDS.map((c) => {
      const d = cards[c.key] || {};
      const show = (v) => (c.fmt ? c.fmt(v) : days(v, unidade));
      if (d.status && d.status !== 'ok') {
        return (
          <Card key={c.key} data-testid={`logistics-card-${c.key}`}>
            <CardContent className="p-5">
              <p className="text-xs text-muted-foreground uppercase tracking-wider whitespace-nowrap overflow-hidden text-ellipsis">{c.label}</p>
              <p className="text-sm text-muted-foreground mt-3" data-testid={`logistics-card-${c.key}-notice`}>{fieldMessage(d.status, d.field, ctx)}</p>
            </CardContent>
          </Card>
        );
      }
      return (
        <Card key={c.key} data-testid={`logistics-card-${c.key}`}>
          <CardContent className="p-5" style={{ containerType: 'inline-size' }}>
            <p className="text-xs text-muted-foreground uppercase tracking-wider whitespace-nowrap overflow-hidden text-ellipsis">{c.label}</p>
            <p className="font-mono font-bold mt-2 whitespace-nowrap" style={{ fontSize: 'clamp(1.1rem, 9cqi, 1.9rem)' }} data-testid={`logistics-card-${c.key}-value`}>
              {show(d.value)}
            </p>
            <p className="text-xs mt-1 whitespace-nowrap overflow-hidden text-ellipsis">
              <Delta value={d.delta_pct} /> <span className="text-muted-foreground">· antes: {show(d.previous)}</span>
            </p>
          </CardContent>
        </Card>
      );
    })}
  </div>
);
